import BASE_RULE from '../baseRule';
import {SearchTypeRelatedAssets} from './constants';
import {SavedSearchRule} from './types';

export const relatedAssetsRuleDefaults: SavedSearchRule = {
	...BASE_RULE,
	elementType: SearchTypeRelatedAssets,
	elementSubType1: 4,
	elementSubType2: 0,
	elementValue1: 0,
};

export default relatedAssetsRuleDefaults;
